import TournamentModel from './model-tournament';

/**
 * Sport model
 */
export default class FullSportModel {
  constructor(data) {
    this.id = data.id;
    this.is3way = data.is3way;
    this.name = data.n;
    this.class = data.c;
    this.tabs = data.t ? data.t.map(t => new TournamentModel(t, data.id, data.is3way)) : [];
  }
}